import { useEffect } from 'react';
import { Container } from '~/Common';
import { PageBanner as PageBannerStyled } from './styled';
import { useDispatch } from 'react-redux';
import { setTransparentHeader } from 'features/theme/themeSlice';
import { Image } from 'theme-ui';

export const PageBanner = ({ children, variant, img, heightOverride, ...props }) => {
    const dispatch = useDispatch();

    let imgHeight;
    switch (img) {
        case "1":
            imgHeight = '500px';
            break;
        case 'industries':
            imgHeight = '1440px';
            break;
        default:
            imgHeight = '100%';
    }
    imgHeight = heightOverride ? heightOverride : imgHeight;

    // Set header to transparent on mount
    useEffect(() => {
        const onScroll = () => {
            if (window.scrollY >= 40) {
                dispatch(setTransparentHeader(false));
            } else {
                dispatch(setTransparentHeader(true));
            }
        };

        document.addEventListener("scroll", onScroll, false);
        onScroll();

        return () => {
            document.removeEventListener("scroll", onScroll, false);
            dispatch(setTransparentHeader(false));
        }
    }, [dispatch]);

    return (
        <PageBannerStyled industries={img === 'industries'} {...props}>
            <Image src={`/img/header-banner-${img ?? '1'}.png`} sx={{
                position: 'absolute',
                left: 0,
                top: 0,
                right: 0,
                bottom: 0,
                zIndex: 1,
                width: '100%',
                height: imgHeight,
            }}/>
            <Container variant={variant ?? 'layouts.pageBanner'} sx={{ position: 'relative', zIndex: 10 }}>
                {children}
            </Container>
        </PageBannerStyled>
    );
};
